// Geometry in grid units, each a quarter of the board width.
export const DASHBOARD_TILE_SIZES = {
  quarter: {columns: 1, rows: 1},
  half: {columns: 2, rows: 1},
  tall: {columns: 2, rows: 2},
  wide: {columns: 4, rows: 1},
  large: {columns: 4, rows: 2},
} as const;
